<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>The Pandora Papers shows that more than 300 politicians, from more than 90 countries and territories, had offshore companies in secrecy jurisdictions.</p>
    <stacked-bar-chart
      :data="tsv"
      :social-mode="socialMode"
      :fixed-height="fixedHeight"
      hide-legend
      class="mt-4" />
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'
import { sortBy } from 'lodash'

export default {
  mixins: [chart],
  name: 'ChartPoliticiansForEachRegion',
  computed: {
    tsv () {
      return sortBy(this.$options.tsv, ({ value }) => -value)
    }
  }
}
</script>

<tsv>
label	value
Africa	49
Americas	92
Asia	68
Europe	90
Middle East	37
</tsv>
